module.exports = __webpack_public_path__ + "static/media/25-SilvaDias.4db24662.png";